export default __webpack_public_path__ + "static/media/freya4.8cb3e7b5.jpg";